import { MilitaryTech } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const rankingProfit = {
    id: 'rankingProfit',
    type: 'group',
    children: [
        {
            id: 'rankingProfit',
            title: 'Ranking Profit',
            type: 'item',
            url: '/rankingProfits',
            icon: MilitaryTech,
            breadcrumbs: false
        }
    ]
};

export default rankingProfit;
